import { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';

import { Container, Grid, SectionText } from '@/atoms';
import { CardBlog } from '@/molecules';

import type { FunctionComponent } from 'react';
import type { TypeBlogProps } from './types';

/**
 * Blog
 */
export const Blog: FunctionComponent<TypeBlogProps> = ({
  className = '',
  backgroundColorBottom,
  backgroundColorBottomMobile,
  backgroundColorTop,
  backgroundColorTopMobile,
  caption,
  cutLevel = 50,
  cutLevelMobile = 50,
  desc,
  posts,
  textColor,
  title,
}: TypeBlogProps) => {
  const [cardsToShow, setCardsToShow] = useState(posts);
  const [labels, setLabels] = useState([]);
  const { t } = useTranslation('common');

  useEffect(() => {
    const temp: string[] = [];
    temp.push(t('components.templates.facilities.filter'));

    posts.map((post) => {
      if (
        post?.categories?.nodes?.[0]?.name &&
        !temp.includes(post?.categories?.nodes?.[0]?.name)
      ) {
        temp.push(post?.categories?.nodes?.[0]?.name);
      }
    });

    temp.filter(Boolean);
    //eslint-disable-next-line
    //@ts-ignore
    setLabels(temp);
  }, []);

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    setCardsToShow(
      posts.filter((post) =>
        selectedIndex === 0
          ? true
          : post?.categories?.nodes?.[0]?.name === labels[selectedIndex]
      )
    );
  }, [selectedIndex]);

  return (
    <Container
      backgroundColorBottom={backgroundColorBottom}
      backgroundColorTopMobile={backgroundColorTopMobile}
      backgroundColorTop={backgroundColorTop}
      backgroundColorBottomMobile={backgroundColorBottomMobile}
      cutLevel={cutLevel === null ? 50 : cutLevel}
      cutLevelMobile={cutLevelMobile === null ? 50 : cutLevelMobile}
      className={`flex flex-col gap-10 ${className}`}
    >
      <SectionText
        title={title}
        direction="row"
        textAlign="start"
        variant={textColor}
        caption={caption}
        desc={desc}
      />

      <div className="grid grid-cols-2 grid-rows-2 gap-6 overflow-auto sm:flex sm:flex-row">
        {labels.map((label: string, index: number) => (
          <div
            className={`text-body text-body--primary--bold flex cursor-pointer items-center justify-center  rounded-full border px-4 py-1 transition-all   ${
              selectedIndex === index
                ? 'border-primary-600 bg-primary-600 font-bold text-white'
                : 'border-primary-400 text-primary-400'
            }`}
            key={index}
            onClick={() => setSelectedIndex(index)}
          >
            {label}
          </div>
        ))}
      </div>

      <Grid className="!gap-5">
        {cardsToShow.map((card, index: number) => (
          <Grid.Item key={index}>
            <CardBlog {...card} className="h-full" />
          </Grid.Item>
        ))}
      </Grid>
    </Container>
  );
};

Blog.displayName = 'Blog';
